<div class="px-4 py-5 my-5 text-center">
  <img class="d-block mx-auto mb-4" src="./assets/img/logo.png" alt="">
  <h1 class="display-5 fw-bold"></h1>
  <div class="col-lg-6 mx-auto">
    <p class="lead mb-4">L'acquisto al momento potrebbe essere disabilitato, se il problema persiste ti preghiamo di
      contattarci saremo felici di seguirla telefonicamente.</p>
  </div>
</div>
